import React from 'react';

import './styles.css';


const Component = props => (
  <div styleName="surveyOptionMain">
    <div>
      <input
        styleName="surveyOptionBox"
        type="checkbox"
        onChange={props.onChange}
        checked={props.checked}
      />
    </div>
    <div styleName="labelText">
      { props.children }
    </div>
  </div>
);

Component.displayName = 'SurveyOption';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Forms/Controls/SurveyOption.js